import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import AutoBidMatrixService from "../services/externalServices/autoBidMatrixServices";
import CruzeTypeServices from "../services/externalServices/cruzeTypeServices";
import RiderServices from "../services/externalServices/riderServices";
import PackageServices from "../services/externalServices/TourPackageServices/packageServices";
import ZoneService from "../services/externalServices/zoneServices";
import CityService from "../services/externalServices/citiesServices";
import AdminServices from "../services/externalServices/adminServices";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DataGrid } from "@mui/x-data-grid";
import Airconditioner from "../../assets/images/icons/air-conditioner.png";
import NonAC from "../../assets/images/icons/no-air-conditioner.png";

const AutoBidMatrix = () => {
  const dispatch = useDispatch();
  const {
    firstname,
    lastname,
    role = "",
    _id,
  } = JSON.parse(localStorage.getItem("admin"));
  const createById = _id;
  console.log("createById", createById);
  const { serviceType } = useSelector((state) => state.serviceType.serviceType);
  const initialForm = {
    city: "",
    serviceAssociated: "",
   
    partnerId: "",
    cruzeId: "",
    key_tourPackages: "",
     serviceType: "",
    // key_airport: "",
    // key_rental: "",
    // key_auto: "",
    pickupZones: null,
    dropZones: null,
    // pickupDayOffset: 0,
    pickupTimeOffset: 0,
    pricing: {
      ac: "",
      nonAc: "",
    },
    title: "",
    accountType: "",
    isEnabled: true,
    comments: "",
    createdBy: createById,
    updatedBy: createById,
  };

  const [formData, setFormData] = useState(initialForm);
  const [matrices, setMatrices] = useState([]);
  const [editId, setEditId] = useState(null);
  const [cruzeTypes, setCruzeTypes] = useState([]);
  const [riders, setRiders] = useState([]);
  const [keyPackages, setKeyPackages] = useState([]);
  const [zones, setZones] = useState([]);
  const [cities, setCities] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [pickupZoneFilter, setPickupZoneFilter] = useState("");
  const [driverSearch, setDriverSearch] = useState("");
  const [selectedPickupZone, setSelectedPickupZone] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [driverSuggestions, setDriverSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState("");

  useEffect(() => {
    fetchMatrices();
    fetchCruzeTypes();
    fetchRiders();
    fetchKeyPackages();
    fetchZones();
    fetchCities();
    fetchAdmins();
  }, []);

  useEffect(() => {
    if (formData.serviceAssociated) {
      fetchCruzeTypes();
      fetchRiders();
    }
  }, [formData.serviceAssociated]);

  useEffect(() => {
    if (driverSearch.trim() === "") {
      setDriverSuggestions([]);
      return;
    }

    const suggestions = riders.filter((rider) => {
      const fullName = `${rider.first_name || ""} ${
        rider.last_name || ""
      }`.toLowerCase();
      const phone = String(rider.phone_number || "");
      return (
        fullName.includes(driverSearch.toLowerCase()) ||
        phone.includes(driverSearch)
      );
    });

    setDriverSuggestions(suggestions);
  }, [driverSearch, riders]);

  const fetchMatrices = async () => {
    try {
      const res = await AutoBidMatrixService.getAllAutoBidMatrices();
      setMatrices(res);
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "Failed to fetch matrices",
        severity: "error",
      });
    }
  };

  const fetchCruzeTypes = async () => {
    try {
      const res = await CruzeTypeServices.getCruzeType();
      const filteredCruzeTypes = res.filter(
        (cruze) => cruze.serviceAssociated === formData.serviceAssociated
      );
      setCruzeTypes(filteredCruzeTypes);
    } catch (error) {
      console.error("Error fetching CruzeTypes", error);
    }
  };

  const fetchRiders = async () => {
    try {
      const res = await RiderServices.getDrivers(formData.serviceAssociated);
      // console.log("Riders fetched:", res);
      const filteredRiders = res.filter((rider) => rider.is_approved);
      // console.log("formData.serviceAssociated ", formData.serviceAssociated);
      // console.log("filteredRiders", filteredRiders);
      setRiders(filteredRiders);
    } catch (error) {
      console.error("Error fetching Riders", error);
    }
  };

  const fetchKeyPackages = async () => {
    try {
      const res = await PackageServices.getPackages();
      setKeyPackages(res);
    } catch (error) {
      console.error("Error fetching getPackages", error);
    }
  };

  const fetchZones = async () => {
    try {
      const res = await ZoneService.getAllZones();
      setZones(res);
    } catch (error) {
      console.error("Error fetching getAllZones", error);
    }
  };

  const fetchCities = async () => {
    try {
      const res = await CityService.getAllCities();
      setCities(res);
    } catch (error) {
      console.error("Error fetching getAllCities", error);
    }
  };

  const fetchAdmins = async () => {
    try {
      const res = await AdminServices.getAlladmins();
      setAdmins(res);
    } catch (error) {
      console.error("Error fetching getAlladmins", error);
    }
  };

  const handleDriverSelect = (driver) => {
    const fullName = `${driver.first_name} ${driver.last_name}`;
    setDriverSearch(fullName);
    setShowSuggestions(false);
  };

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   if (name.startsWith("pricing.")) {
  //     const key = name.split(".")[1];
  //     setFormData((prev) => ({
  //       ...prev,
  //       pricing: { ...prev.pricing, [key]: value },
  //     }));
  //   } else if (type === "checkbox") {
  //     setFormData((prev) => ({ ...prev, [name]: checked }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }
  // };

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   if (name.startsWith("pricing.")) {
  //     const key = name.split(".")[1];
  //     setFormData((prev) => ({
  //       ...prev,
  //       pricing: { ...prev.pricing, [key]: value },
  //     }));
  //   } else if (type === "checkbox") {
  //     setFormData((prev) => ({ ...prev, [name]: checked }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //       // Automatically sync serviceType when serviceAssociated changes
  //       ...(name === "serviceAssociated" && { serviceType: value }),
  //     }));
  //   }
  // };

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  if (name.startsWith("pricing.")) {
    const key = name.split(".")[1];
    setFormData((prev) => ({
      ...prev,
      pricing: { ...prev.pricing, [key]: value },
    }));
  } else if (type === "checkbox") {
    setFormData((prev) => ({ ...prev, [name]: checked }));
  } else if (name === "key_tourPackages") {
    // Find the selected package
    const selectedPackage = keyPackages.find(pkg => pkg._id === value);
     console.log("selectedPackage?.packageCategory",selectedPackage?.packageCode)
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      // Set serviceAssociated based on packageCategory
      // serviceAssociated: selectedPackage?.packageCategory === "AIRPORT01" 
      //   ? "Airport_pickup" 
      //   : "TourPackage",
     
   serviceType: selectedPackage?.packageCode === "AIRPORT_PICKUP" ? "AirportPickup" :
                 selectedPackage?.packageCode === "AIRPORT_DROP" ? "AirportDrop" : "TourPackage" || ""
    }));
  } else {
    setFormData((prev) => ({  
      ...prev,
      [name]: value,
      // Keep existing sync for other cases
      ...(name === "serviceAssociated" && { serviceType: value }),
    }));
  }
};

  //  const filteredRows = matrices?.filter((row) => {
  //   const matchesPickup = row.pickupZones?.zoneName
  //     ?.toLowerCase()
  //     .includes(pickupZoneFilter.toLowerCase());

  //   const fullName = `${row.partnerId?.first_name || ""} ${row.partnerId?.last_name || ""}`.toLowerCase();

  //   const phone = String(row.partnerId?.phone_number || "");

  //   const matchesDriver =
  //     fullName.includes(driverSearch.toLowerCase()) ||
  //     phone.includes(driverSearch.toLowerCase());

  //   return matchesPickup && matchesDriver;
  // });

  // const filteredRows = matrices?.filter((row) => {
  //   const matchesCity = selectedCity ? row.city?._id === selectedCity : true;

  //   const matchesPickup = selectedPickupZone
  //     ? row.pickupZones?._id === selectedPickupZone
  //     : true;

  //   const fullName = `${row.partnerId?.first_name || ""} ${
  //     row.partnerId?.last_name || ""
  //   }`.toLowerCase();
  //   const phone = String(row.partnerId?.phone_number || "");
  //   const matchesDriver =
  //     fullName.includes(driverSearch.toLowerCase()) ||
  //     phone.includes(driverSearch.toLowerCase());

  //   return matchesCity && matchesPickup && matchesDriver;
  // });

  const filteredRows = matrices?.filter((row) => {
    const matchesCity = selectedCity ? row.city?._id === selectedCity : true;

    const matchesPickup = selectedPickupZone
      ? row.pickupZones?._id === selectedPickupZone
      : true;
    // console.log("selectedVehicle", selectedVehicle);
    const matchesVehicle = selectedVehicle
      ? row.cruzeId?._id === selectedVehicle // Adjust based on your data structure
      : true;
    // console.log("matchesVehicle", matchesVehicle);
    // console.log("row.cruzeTypes?._id", row);

    const fullName = `${row.partnerId?.first_name || ""} ${
      row.partnerId?.last_name || ""
    }`.toLowerCase();
    const phone = String(row.partnerId?.phone_number || "");
    const matchesDriver =
      fullName.includes(driverSearch.toLowerCase()) ||
      phone.includes(driverSearch.toLowerCase());

    return matchesCity && matchesPickup && matchesVehicle && matchesDriver;
  });

  const getZonesForSelectedCity = () => {
    if (!selectedCity) return zones;
    return zones.filter((zone) => zone.cityId?._id === selectedCity);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     if (editId) {
  //       await AutoBidMatrixService.updateAutoBidMatrix(editId, formData);
  //       setSnackbar({
  //         open: true,
  //         message: "Auto Bid Matrix updated successfully!",
  //         severity: "success",
  //       });
  //       setEditId(null);
  //     } else {
  //       await AutoBidMatrixService.addAutoBidMatrix(formData);
  //       setSnackbar({
  //         open: true,
  //         message: "Auto Bid Matrix created successfully!",
  //         severity: "success",
  //       });
  //     }

  //     setFormData(initialForm);
  //     fetchMatrices();
  //   } catch (error) {
  //     console.error(error);
  //     setSnackbar({
  //       open: true,
  //       message: "An error occurred. Please try again.",
  //       severity: "error",
  //     });
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Basic validation - check required fields
  const requiredFields = ['title', 'city', 'serviceAssociated', 'partnerId'];
  const missingFields = requiredFields.filter(field => !formData[field]);

  if (missingFields.length > 0) {
    setSnackbar({
      open: true,
      message: `Please fill in all required fields: ${missingFields.join(', ')}`,
      severity: "error",
    });
    return;
  }

  // Additional validation for TourPackage
  if (formData.serviceAssociated === "TourPackage" && !formData.key_tourPackages) {
    setSnackbar({
      open: true,
      message: "Please select a Tour Package",
      severity: "error",
    });
    return;
  }

  try {
    // Prepare data - convert empty strings to null for ObjectId fields
    const submitData = {
      ...formData,
      dropZones: formData.dropZones || null,
      pickupZones: formData.pickupZones || null,
      city: formData.city || null,
      partnerId: formData.partnerId || null
    };

    if (editId) {
      await AutoBidMatrixService.updateAutoBidMatrix(editId, submitData);
      // if (!response.success) throw new Error(response.message);
      
      setSnackbar({
        open: true,
        message:"Auto Bid Matrix updated successfully!",
        severity: "success",
      });
      setEditId(null);
    } else {
      await AutoBidMatrixService.addAutoBidMatrix(submitData);
      // console.log("response", response);
      // if (!response.success) throw new Error(response.message);
      
      setSnackbar({
        open: true,
        message: "Auto Bid Matrix created successfully!",
        severity: "success",
      });
    }

    setFormData(initialForm);
    fetchMatrices();
  } catch (error) {
    console.error("Submission error:", error);
    setSnackbar({
      open: true,
      message: error.message || "An error occurred. Please try again.",
      severity: "error",
    });
  }
};

  const handleEdit = (matrix) => {
    console.log("editMatrix", matrix);
    setFormData({
      ...matrix,
      serviceAssociated: matrix.serviceAssociated || "",
      city: matrix.city || "",
      partnerId: matrix.partnerId?._id || "",
      cruzeId: matrix.cruzeId?._id || "", // Same for cruzeId if needed
      pickupZones: matrix.pickupZones?._id || "",
      dropZones: matrix.dropZones?._id || "",
      city: matrix.city?._id || "",
      pricing: {
        ac: matrix.pricing?.ac || "",
        nonAc: matrix.pricing?.nonAc || "",
      },
      createdBy: createById || "",
      updatedBy: createById || "",
    });
    setEditId(matrix._id);
    window.scrollTo({ top: 850, behavior: "smooth" });
  };

  const handleClone = (matrix) => {
    // Create a clone of the matrix but without the _id
    const { _id, ...clonedMatrix } = matrix;
    setFormData({
      ...clonedMatrix,
      serviceAssociated: clonedMatrix.serviceAssociated || "",
      city: clonedMatrix.city || "",
      partnerId: clonedMatrix.partnerId?._id || "",
      cruzeId: clonedMatrix.cruzeId?._id || "", // Same for cruzeId if needed
      pickupZones: clonedMatrix.pickupZones?._id || "",
      dropZones: clonedMatrix.dropZones?._id || "",
      city: clonedMatrix.city?._id || "",
      pricing: {
        ac: clonedMatrix.pricing?.ac || "",
        nonAc: clonedMatrix.pricing?.nonAc || "",
      },
      createdBy: createById || "",
      updatedBy: createById || "",
    });
    setEditId(null); // Ensure we're in create mode, not edit mode
    window.scrollTo({ top: 850, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this matrix?")) {
      try {
        await AutoBidMatrixService.deleteAutoBidMatrix(id);
        setSnackbar({
          open: true,
          message: "Matrix deleted successfully",
          severity: "success",
        });
        fetchMatrices();
      } catch (error) {
        console.error(error);
        setSnackbar({
          open: true,
          message: "Failed to delete matrix",
          severity: "error",
        });
      }
    }
  };

  const handleCancelEdit = () => {
    setFormData(initialForm);
    setEditId(null);
  };

  // const getDisplayValue = (id, collection, field = "name") => {
  //   if (!id) return "-";
  //   const item = collection.find((item) => item._id === id);
  //   return item ? item[field] : "-";
  // };
  const getDisplayValue = (id, collection, field = "name") => {
    if (!id) return "-";
    const idToCompare = typeof id === "object" ? id._id : id;
    const item = collection.find((item) => item._id === idToCompare);
    return item ? item[field] : "-";
  };

  const getTourPackageName = (id) => {
    const found = keyPackages.find((pkg) => pkg._id === (id?._id || id));
    // console.log("found", found);
    return found?.detailTitle;
  };

  const clearFilters = () => {
    setSelectedCity("");
    setSelectedPickupZone("");
    setSelectedVehicle("");
    setDriverSearch("");
    setShowSuggestions(false);
  };

  const columns = [
    { field: "title", headerName: "Title", minWidth: 120, flex: 1 },

    {
      field: "city",
      headerName: "City",
      minWidth: 100,
      flex: 1,
      renderCell: (params) =>
        getDisplayValue(params.row?.city, cities, "cityCode") || "-",
    },

    {
      field: "driverName",
      headerName: "Driver Name",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const p = params.row?.partnerId;
        return p ? `${p.first_name || ""} ${p.last_name || ""}` : "-";
      },
    },

    {
      field: "phoneNumber",
      headerName: "Driver PhoneNumber",
      minWidth: 140,
      flex: 1,
      renderCell: (params) => params.row?.partnerId?.phone_number || "-",
    },

    {
      field: "serviceAssociated",
      headerName: "Service",
      minWidth: 120,
      flex: 1,
      renderCell: (params) => params.row?.serviceAssociated || "-",
    },

    {
      field: "vehicleName",
      headerName: "Vehicle Name",
      minWidth: 130,
      flex: 1,
      renderCell: (params) => params.row?.cruzeId?.cruzeName || "-",
    },

    {
      field: "acPrice",
      headerName: "AC Price",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => params.row?.pricing?.ac || "-",
    },

    {
      field: "nonAcPrice",
      headerName: "Non-AC Price",
      minWidth: 110,
      flex: 1,
      renderCell: (params) => params.row?.pricing?.nonAc || "-",
    },

    {
      field: "tourPackageName",
      headerName: "TourPackage Name",
      minWidth: 160,
      flex: 1,
      renderCell: (params) =>
        getTourPackageName(params.row?.key_tourPackages) || "-",
    },

    {
      field: "pickupZone",
      headerName: "Pickup Zone",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => params.row?.pickupZones?.zoneName || "-",
    },

    {
      field: "dropZone",
      headerName: "Drop Zone",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => params.row?.dropZones?.zoneName || "-",
    },
    {
      field: "pickupDayOffset",
      headerName: "Pickup Day Offset",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => params.row?.pickupDayOffset,
      renderHeader: () => (
        <>
          Pickup Day
          <br />
          Offset
        </>
      ),
    },
    {
      field: "pickupTimeOffset",
      headerName: "Pickup Time Offset",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => params.row?.pickupTimeOffset,
      renderHeader: () => (
        <>
          Pickup Time
          <br />
          Offset
        </>
      ),
    },

    {
      field: "isEnabled",
      headerName: "Enabled",
      minWidth: 90,
      flex: 1,
      renderCell: (params) => (params.row?.isEnabled ? "Yes" : "No"),
    },

    {
      field: "actions",
      headerName: "Actions",
      minWidth: 150,
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => handleEdit(params.row)}>
            <EditIcon color="primary" />
          </IconButton>
          <IconButton onClick={() => handleClone(params.row)}>
            <ContentCopyIcon color="action" />
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row._id)}>
            <DeleteIcon color="error" />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex flex-wrap justify-between items-center gap-4 mt-4 mb-4">
        <h2 className="text-xl font-bold">Auto Bid Matrices</h2>

        <button
          onClick={clearFilters}
          className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center gap-2 text-sm mr-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3 w-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
          Clear All Filters
        </button>
      </div>
      {/* <div className="flex flex-wrap gap-2 mb-4"> */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Filter by City
          </label>
          <select
            value={selectedCity}
            onChange={(e) => {
              setSelectedCity(e.target.value);
              setSelectedPickupZone(""); // Reset pickup zone when city changes
            }}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            {/* <option value="">All Cities</option> */}
            {cities.map((city) => (
              <option key={city._id} value={city._id}>
                {city.cityName.en}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Filter by Pickup Zone
          </label>
          <select
            value={selectedPickupZone}
            onChange={(e) => setSelectedPickupZone(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Pickup Zones</option>
            {zones.map((zone) => (
              <option key={zone._id} value={zone._id}>
                {zone.zoneName}
              </option>
            ))}
          </select>
        </div>
        {/* <input
          type="text"
          placeholder="Filter by Pickup Zone"
          className="border p-2 rounded w-60"
          value={pickupZoneFilter}
          onChange={(e) => setPickupZoneFilter(e.target.value)}
        /> */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search Driver
          </label>
          <div className="relative">
            <input
              type="text"
              value={driverSearch}
              onChange={(e) => {
                setDriverSearch(e.target.value);
                setShowSuggestions(true);
              }}
              onFocus={() => setShowSuggestions(true)}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              placeholder="Search by name or phone"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            />

            {showSuggestions && driverSuggestions.length > 0 && (
              <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-md py-1 max-h-60 overflow-auto">
                {driverSuggestions.map((driver) => (
                  <div
                    key={driver._id}
                    className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleDriverSelect(driver)}
                  >
                    <div className="font-medium">
                      {driver.first_name} {driver.last_name}
                    </div>
                    <div className="text-sm text-gray-500">
                      {driver.phone_number}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Filter by Vehicle
          </label>
          <select
            value={selectedVehicle}
            onChange={(e) => setSelectedVehicle(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Vehicles</option>
            {cruzeTypes.map((vehicle) => (
              <option key={vehicle._id} value={vehicle._id}>
                {vehicle.cruzeName}{" "}
                {/* Adjust based on your vehicle object structure */}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          getRowId={(row) => row._id}
          // autoHeight
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableColumnMenu
          rowHeight={45}
        />
      </div>

      <div className="mt-8">
        <h1 className="text-2xl font-bold mb-4">
          {editId ? "Edit" : "Add"} Auto Bid Matrix
        </h1>

        <form
          onSubmit={handleSubmit}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 bg-white p-4 sm:p-6 rounded shadow mb-8"
>
          {Object.keys(initialForm).map((field) => {
            if (field === "createdBy" || field === "updatedBy") {
              return null;
            }
            const shouldDisableOtherKeys =
              formData.serviceAssociated === "TourPackage" &&
              (field === "key_airport" ||
                field === "key_rental" ||
                field === "key_auto")
            if (field === "pricing") {
              return (
                <React.Fragment key="pricing">
                  {/* AC Price */}
                  <div className="relative w-full">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3  pointer-events-none">
                      <img src={Airconditioner} alt="AC" className="w-5 h-5" />
                    </div>
                    <input
                      type="text"
                      id="pricing_ac"
                      name="pricing.ac"
                      value={formData.pricing.ac}
                      onChange={handleChange}
                      placeholder=" "
                      className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 
        bg-transparent rounded-lg border border-gray-300 appearance-none 
        focus:outline-none focus:ring-0 focus:border-blue-600 peer pl-10" // Increased left padding
                    />
                    <label
                      htmlFor="pricing_ac"
                      className="absolute text-sm text-gray-500 duration-300 transform 
        -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 
        peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-1/2 
        peer-placeholder-shown:top-1/2 peer-focus:top-2 left-8  // Adjusted left position
        peer-focus:scale-75 peer-focus:-translate-y-4 
        peer-focus:text-blue-600"
                    >
                      AC Price
                    </label>
                  </div>

                  {/* Non-AC Price */}
                  <div className="relative w-full">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <img
                        src={NonAC}
                        alt="Non-AC"
                        className="w-5 h-5 opacity-40" // Slightly faded for non-AC
                      />
                      <div className="absolute left-6 top-1/2 transform -translate-y-1/2 text-xs text-gray-400">
                        ×
                      </div>
                    </div>
                    <input
                      type="text"
                      id="pricing_nonac"
                      name="pricing.nonAc"
                      value={formData.pricing.nonAc}
                      onChange={handleChange}
                      placeholder=" "
                      className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 
        bg-transparent rounded-lg border border-gray-300 appearance-none 
        focus:outline-none focus:ring-0 focus:border-blue-600 peer pl-12" // More padding for the "×"
                    />
                    <label
                      htmlFor="pricing_nonac"
                      className="absolute text-sm text-gray-500 duration-300 transform 
        -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 
        peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-1/2 
        peer-placeholder-shown:top-1/2 peer-focus:top-2 left-10  // Adjusted left position
        peer-focus:scale-75 peer-focus:-translate-y-4 
        peer-focus:text-blue-600"
                    >
                      Non-AC Price
                    </label>
                  </div>
                </React.Fragment>
              );
            }

            if (field === "isEnabled") {
              return (
                <label
                  key={field}
                  className="col-span-2 flex items-center space-x-2"
                >
                  <input
                    type="checkbox"
                    name="isEnabled"
                    checked={formData.isEnabled}
                    onChange={handleChange}
                  />
                  <span>Is Enabled</span>
                </label>
              );
            }
            if (field === "serviceAssociated") {
              return (
                <select
                  name="serviceAssociated"
                  value={formData.serviceAssociated || ""}
                  onChange={handleChange}
                  className="border p-2 rounded"
                >
                  <option value="">Select Service</option>
                  <option value="TourPackage">Tour Packages</option>
                  <option value="Auto">Auto</option>
                  {/* <option value="airport">Airport</option>
                  <option value="rental">Rental</option> */}
                </select>
              );
            }
            if (field === "serviceType") {
              return (
                <div key={field} className="relative">
                  <label
                    htmlFor={field}
                    className="absolute text-sm text-gray-500 duration-300 transform 
               -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 
               peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-1/2 
               peer-placeholder-shown:top-1/2 peer-focus:top-2 
               peer-focus:scale-75 peer-focus:-translate-y-4 
               peer-focus:text-blue-600"
                  >
                    {field
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </label>
                  <input
                    type="text"
                    name="serviceType"
                    // onChange={handleChange}
                    readOnly
                    value={formData.serviceType || ""}
                    className="border p-2 rounded bg-gray-100 text-gray-500"
                    disabled
                  />
                </div>
              );
            }
            if (field === "accountType") {
              return (
                <select
                  key={field}
                  name="accountType"
                  value={formData.accountType}
                  onChange={handleChange}
                  className="border p-2 rounded"
                >
                  <option value="">Select AccountType</option>
                  <option value="I">I</option>
                  <option value="C">C</option>
                </select>
              );
            }

            if (field === "cruzeId") {
              return (
                <select
                  key={field}
                  name="cruzeId"
                  value={formData.cruzeId}
                  onChange={handleChange}
                  className="border p-2 rounded"
                >
                  <option value="">Select Cruze Type</option>
                  {cruzeTypes.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.cruzeName}
                    </option>
                  ))}
                </select>
              );
            }
            if (field === "city") {
              // Auto-select without useEffect
              if (cities?.length === 1 && !formData.city) {
                setTimeout(() => {
                  setFormData((prev) => ({
                    ...prev,
                    city: cities[0]._id,
                  }));
                }, 0);
              }

              return (
                <div className="relative w-full">
                  <select
                    name="city"
                    value={formData.city || ""}
                    onChange={handleChange}
                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 
          bg-transparent rounded-lg border border-gray-300 appearance-none 
          focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    disabled={cities?.length === 1}
                  >
                    {cities?.length > 1 && (
                      <option value="">Select City</option>
                    )}
                    {cities?.map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.cityCode}
                      </option>
                    ))}
                  </select>
                  <label
                    htmlFor="city"
                    className="absolute text-sm text-gray-500 duration-300 transform 
          -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 
          peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-1/2 
          peer-placeholder-shown:top-1/2 peer-focus:top-2 
          peer-focus:scale-75 peer-focus:-translate-y-4 
          peer-focus:text-blue-600"
                  >
                    City
                  </label>
                </div>
              );
            }

            if (field === "partnerId") {
              return (
                <select
                  name="partnerId"
                  value={formData.partnerId || ""}
                  onChange={handleChange}
                  className="border p-2 rounded"
                >
                  <option value="">Select Partner</option>
                  {riders.map((r) => (
                    <option key={r._id} value={r._id}>
                      {r.first_name} {r.last_name} - {r.phone_number}
                    </option>
                  ))}
                </select>
              );
            }

            if (field === "key_tourPackages") {
              const isDisabled =
                formData.serviceAssociated !== "TourPackage" &&
                formData.serviceAssociated !== "";
              return (
                <select
                  key={field}
                  name="key_tourPackages"
                  value={formData.key_tourPackages}
                  onChange={handleChange}
                  className={`border p-2 rounded ${
                    isDisabled
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={isDisabled}
                >
                  <option value="">Select Key tourPackages</option>
                  {keyPackages.map((r) => (
                    <option
                      key={r._id}
                      value={r._id}
                      className={isDisabled ? "text-gray-400" : ""}
                    >
                      {r.listHeading}
                    </option>
                  ))}
                </select>
              );
            }

            if (field === "pickupZones") {
              return (
                <div key={field} className="flex flex-col gap-4">
                  <div>
                    <label className="block mb-1 font-medium">
                      Pickup Zone
                    </label>
                    <select
                      name="pickupZones"
                      value={formData.pickupZones}
                      onChange={handleChange}
                      className="border p-2 rounded w-full"
                    >
                      <option value="">Select Pickup Zone</option>
                      {zones.map((zone) => (
                        <option key={zone._id} value={zone._id}>
                          {zone.zoneName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              );
            }
            if (field === "dropZones") {
              const disabled = formData.serviceType === "TourPackage";
              return (
                <div>
                  <label className="block mb-1 font-medium">Drop Zone</label>
                  <select
                    name="dropZones"
                    value={formData.dropZones}
                    onChange={handleChange}
                    // className="border p-2 rounded w-full"
                    className={
                      disabled ? "text-gray-400" : "border p-2 rounded w-full"
                    }
                    disabled={disabled} // Disable if pickup zone is not selected
                  >
                    <option value="">Select Drop Zone</option>
                    {zones.map((zone) => (
                      <option key={zone._id} value={zone._id}>
                        {zone.zoneName}
                      </option>
                    ))}
                  </select>
                </div>
              );
            }
            if (field === "pickupTimeOffset") {
              return (
                <div key={field} className="flex flex-col">
                  <label className="block mb-1 font-medium">
                    Pickup Time Offset (hours)
                  </label>
                  <div className="flex items-center">
                    <button
                      type="button"
                      onClick={() => {
                        const newValue = Math.max(0, formData[field] - 0.25);
                        handleChange({
                          target: {
                            name: field,
                            value: newValue,
                          },
                        });
                      }}
                      className="px-3 py-1 border rounded-l bg-gray-100 hover:bg-gray-200"
                    >
                      -
                    </button>
                    <input
                      // type="number"
                      name={field}
                      value={formData[field]}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value) || 0;
                        handleChange({
                          target: {
                            name: field,
                            value: Math.max(0, value), // Ensure it doesn't go negative
                          },
                        });
                      }}
                      // step="0.25"
                      // min="0"
                      className="border-t border-b border-r-0 border-l-0 p-2 w-20 text-center"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newValue = formData[field] + 0.25;
                        handleChange({
                          target: {
                            name: field,
                            value: newValue,
                          },
                        });
                      }}
                      className="px-3 py-1 border rounded-r bg-gray-100 hover:bg-gray-200"
                    >
                      +
                    </button>
                  </div>
                </div>
              );
            }

            // if (field === "createdBy") {
            //   return (
            //     <div key={field} className="relative w-full">
            //       <label className="block mb-1 font-medium">Created By</label>
            //       <select
            //         name="createdBy"
            //         value={createById}
            //         onChange={handleChange}
            //         className="border p-2 rounded w-full bg-gray-100 cursor-not-allowed"
            //         disabled
            //       >
            //         <option value={createById}>
            //           {firstname + " " + lastname}
            //         </option>
            //       </select>
            //     </div>
            //   );
            // }

            // if (field === "updatedBy") {
            //   return (
            //     <div key={field} className="relative w-full">
            //       <label className="block mb-1 font-medium">Created By</label>
            //       <select
            //         name="updatedBy"
            //         value={createById}
            //         onChange={handleChange}
            //         className="border p-2 rounded w-full bg-gray-100 cursor-not-allowed"
            //         disabled
            //       >
            //         <option value={createById}>
            //           {firstname + " " + lastname}
            //         </option>
            //       </select>
            //     </div>
            //   );
            // }

            return (
              <div key={field} className="relative w-full">
                <input
                  type="text"
                  id={field}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  placeholder=" "
                  disabled={shouldDisableOtherKeys}
                  className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 
       bg-transparent rounded-lg border border-gray-300 appearance-none 
       focus:outline-none focus:ring-0 focus:border-blue-600 peer
       ${shouldDisableOtherKeys ? "bg-gray-100 cursor-not-allowed" : ""}`}
                />
                <label
                  htmlFor={field}
                  className={`absolute text-sm duration-300 transform 
       -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 
       peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-1/2 
       peer-placeholder-shown:top-1/2 peer-focus:top-2 
       peer-focus:scale-75 peer-focus:-translate-y-4 
       peer-focus:text-blue-600
       ${shouldDisableOtherKeys ? "text-gray-400" : "text-gray-500"}`}
                >
                  {field
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())}
                </label>
              </div>
            );
          })}

          <div className="col-span-2 flex justify-end space-x-2">
            {editId && (
              <button
                type="button"
                onClick={handleCancelEdit}
                className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600"
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
            >
              {editId ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default AutoBidMatrix;
